<template>
    <div class="appoint-cont">
        <el-form label-position="right" :rules="rules" label-width="100px" ref="appointForm" :model="appointData">
            <div>
                <el-form-item :rules="[
                        { required: !appointData.exceptionType, message: '请选择送装需求', trigger: 'change' }
                    ]"
                    label="送装需求" prop="factInstallType">
                     <!-- DP单独配置 -->
                    <el-select
                        v-model="appointData.factInstallType"
                        placeholder="请选择"
                        @change="getSelectValue"
                        v-if="rowData.orderType === 'DP'"
                    >
                        <el-option value="PICKUP" label="上门取件" key="PICKUP"></el-option>
                    </el-select>
                      <!-- NET(2B)单独配置 -->
                        <el-select
                            v-model="appointData.factInstallType"
                            placeholder="请选择"
                            @change="getSelectValue"
                            v-else-if="rowData.deliveryType === 'NET' || rowData.businessMode === 'B2B'"
                        >
                            <el-option value="DELIVERYONLY" label="配送" key="DELIVERYONLY"></el-option>
                        </el-select>
                        <selects
                        v-else
                        width='100%'
                        :mValue="appointData.factInstallType"
                        :optionNum="'INSTALL_TYPE'"
                        :prop="'factInstallType'"
                        @getSelectValue="getSelectValue"
                    >
                    </selects>
                </el-form-item>
            </div>
            <el-form-item label="预约配送时间" :required="!appointData.exceptionType">
                <div class="row-item">
                    <el-form-item prop="appointDate" :rules="[
                        { required: !appointData.exceptionType, message: '请选择配送日期', trigger: 'change' }
                    ]">
                        <el-date-picker v-model="appointData.appointDate" class="appoint-date"
                            value-format="yyyy-MM-dd" placeholder="预约配送日期" type="date"
                            :picker-options="pickerOptions" :clearable="false" @change="changeVal"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item prop="appointTime" class="row-item-ml">
                        <el-select v-model="appointData.appointTime" placeholder="预约配送时间" :clearable="false"
                            @change="changeVal">
                            <el-option v-for="item in timeSlotOptions" :key="item.key" :value="item.value" :label="item.label"
                            :disabled="delieveryTimeSlotDisabled(item)"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </el-form-item>
            <el-form-item label="预约安装时间">
                <div class="row-item">
                    <el-form-item>
                        <el-date-picker v-model="appointData.appointmentSetupDate" class="appoint-date"
                            value-format="yyyy-MM-dd" placeholder="预约安装日期" type="date"
                            :picker-options="pickerOptions"
                            :disabled="appointData.factInstallType !== 'DELIVERYFIRST'"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item class="row-item-ml">
                        <el-select v-model="appointData.appointmentSetupTime" placeholder="预约安装时间" clearable
                            :disabled="appointData.factInstallType !== 'DELIVERYFIRST'">
                            <el-option v-for="item in timeSlotOptions" :key="item.key" :value="item.value" :label="item.label"
                            :disabled="timeSlotOptionsDisabled(item)"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </el-form-item>
            <el-form-item label="备注">
                <el-input type="text" v-model="appointData.appointRemark" clearable />
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import dayjs from 'dayjs';
import selects from '@/components/lots/otpSelect';
import api from '../../../../api/netTaskManage2c.js';
import { dictWithUrl } from '@/components/lots/api.js';
export default {
    components: { selects },
    props: {
        rowData: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    data() {
        return {
            appointData: {
                factInstallType: '',
                appointDate: '',
                appointTime: '',
                appointmentSetupDate: '',
                appointmentSetupTime: '',
                appointRemark: ''
            },
            rules: {},
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
                }
            },
            timeSlotOptions: [
                { value: '06:00:00-08:00:00', label: '06:00-08:00' },
                { value: '08:00:00-10:00:00', label: '08:00-10:00' },
                { value: '10:00:00-12:00:00', label: '10:00-12:00' },
                { value: '12:00:00-14:00:00', label: '12:00-14:00' },
                { value: '14:00:00-16:00:00', label: '14:00-16:00' },
                { value: '16:00:00-18:00:00', label: '16:00-18:00' },
                { value: '18:00:00-20:00:00', label: '18:00-20:00' },
                { value: '20:00:00-22:00:00', label: '20:00-22:00' }
            ],
            currentDate: dayjs().format('YYYY-MM-DD')
        };
    },
    methods: {
        initInstallTimeData(data) {
            const appointData = this.appointData;
            if (appointData.factInstallType === 'DELIVERYONLY') {
                appointData.appointmentSetupDate = appointData.appointmentSetupTime = '';
            } else if (appointData.factInstallType === 'INTEGRATE') {
                appointData.appointmentSetupDate = appointData.appointDate;
                appointData.appointmentSetupTime = appointData.appointTime;
            }
        },
        getSelectValue(data) {
            this.appointData = { ...this.appointData, ...data };
            this.initInstallTimeData();
        },
        changeVal(date) {
            this.initInstallTimeData();
        },
        limitMes(appointData) {
            if (appointData.factInstallType === 'DELIVERYFIRST') {
                const setAppointTime = appointData.appointDate + ' ' +
                    (appointData.appointTime ? appointData.appointTime.split('-')[0] : '23:59:59');
                const setInstallTime = appointData.appointmentSetupDate + ' ' +
                    (appointData.appointmentSetupTime ? appointData.appointmentSetupTime.split('-')[0] : '23:59:59');
                if (new Date(setInstallTime).getTime() - new Date(setAppointTime).getTime() < 0) return '预约安装时间不能小于配送时间！';
            }
        },
        checkSave(selectedData) {
            this.$refs.appointForm.validate((valid) => {
                if (valid) {
                    if (this.limitMes(this.appointData)) {
                        this.$emit('saveResult');
                        return this.$message.warning(this.limitMes(this.appointData));
                    };
                    if (!this.appointData.appointTime) {
                        this.$emit('saveResult');
                        return this.$message.warning('预约配送时间必填！');
                    }
                    if (this.appointData.appointmentSetupDate && !this.appointData.appointmentSetupTime) {
                        this.$emit('saveResult');
                        return this.$message.warning('请补全预约安装时间！');
                    }
                    if (this.appointData.appointTime) {
                        this.appointData.deliveryStartTime = this.appointData.appointDate + ' ' + this.appointData.appointTime.split('-')[0];
                        this.appointData.deliveryEndTime = this.appointData.appointDate + ' ' + this.appointData.appointTime.split('-')[1];
                    } else {
                        this.appointData.deliveryStartTime = this.appointData.deliveryEndTime = '';
                    }
                    if (this.appointData.appointmentSetupTime) {
                        this.appointData.installStartTime = this.appointData.appointmentSetupDate + ' ' + this.appointData.appointmentSetupTime.split('-')[0];
                        this.appointData.installEndTime = this.appointData.appointmentSetupDate + ' ' + this.appointData.appointmentSetupTime.split('-')[1];
                    } else {
                        this.appointData.installStartTime = this.appointData.installEndTime = '';
                    }
                    const { deliveryStartTime, deliveryEndTime, installStartTime, installEndTime, appointRemark, factInstallType } = this.appointData;
                    const params = {
                        deliveryStartTime,
                        deliveryEndTime,
                        installStartTime,
                        installEndTime,
                        appointRemark,
                        factInstallType
                    };
                    let pickupCheck = 0;
                    let netCheck = 0;
                    let all = 0;

                    selectedData.forEach(item => {
                        if (item.orderType === 'DP') {
                            pickupCheck++;
                        }
                        if (item.orderType !== 'DP') {
                            all++;
                        }
                        if (item.deliveryType === 'NET' || item.businessMode === 'B2B') {
                            netCheck++;
                        }
                    });

                    if (this.appointData.factInstallType !== 'PICKUP' && pickupCheck) {
                        this.$emit('saveResult');
                        return this.$message.warning('上门取件单只能选择上门取件方式！');
                    }
                    if (this.appointData.factInstallType === 'PICKUP' && all) {
                        this.$emit('saveResult');
                        return this.$message.warning('只有上门取件单才能选择上门取件方式！');
                    }
                    if (this.appointData.factInstallType !== 'DELIVERYONLY' && netCheck) {
                        this.$emit('saveResult');
                        return this.$message.warning('网点配送单或者B2B订单只能选择配送方式！');
                    }
                    const taskNoList = selectedData.map(item => {
                        return {
                            orderNo: item.orderNo,
                            waybillNo: item.waybillNo,
                            ...params
                        };
                    });
                    api.networkAppointment(taskNoList).then(res => {
                        this.$emit('saveResult', res && +res.code === 0);
                    }).catch(() => {
                        this.$emit('saveResult');
                    });
                } else {
                    this.$emit('saveResult');
                }
            });
        },
        async getOptionList() {
            // 获取时间选项
            const dictData = await dictWithUrl('NET_APPOINT_TIME_SLOT');
            const timeSlot = dictData.data.NET_APPOINT_TIME_SLOT || {};
            const timeSlotOptionsArrVal = Object.entries(timeSlot).sort();
            if (timeSlotOptionsArrVal && timeSlotOptionsArrVal.length) {
                this.timeSlotOptions = [];
                timeSlotOptionsArrVal.forEach(item => {
                    this.timeSlotOptions.push({
                        value: item[0],
                        label: item[1]
                    });
                });
            }
        }
    },
    computed: {
        delieveryTimeSlotDisabled() {
            return function(item) {
                const appointDate = this.appointData.appointDate;
                if (appointDate && dayjs(appointDate).format('YYYY-MM-DD') === this.currentDate) {
                    if (item.value && item.value.split('-')[1].split(':')[0] < dayjs().hour()) return true;
                    return false;
                }
            };
        },
        timeSlotOptionsDisabled() {
            return function(item) {
                const appointmentSetupDate = this.appointData.appointmentSetupDate;
                if (appointmentSetupDate && dayjs(appointmentSetupDate).format('YYYY-MM-DD') === this.currentDate) {
                    if (item.value && item.value.split('-')[1].split(':')[0] < dayjs().hour()) return true;
                    return false;
                }
            };
        }
    },
    mounted() {
        this.getOptionList();
    },
    watch: {
        rowData: function () {
            this.appointData.appointmentSetupDate = '';
            this.appointData.appointmentSetupTime = '';
        }
    }
};
</script>
<style lang="less">
.appoint-cont {
    .row-item {
        display: flex;
    }
    .appoint-reason {
        width: 100%;
    }
    .row-item-ml {
        margin-left: 10px;
    }
    .appoint-date {
        width: 100%;
    }
    .el-select{
        width: 100%;
    }
    .el-form-item{
        margin-bottom: 10px;
    }
}
</style>